import styled from "styled-components";
import "@fontsource/open-sans";
import {
  textAnimation,
  OddImageSectionAnimation,
  OddScreenSectionAnimation,
} from "../../constants/observerKeyframes";

export const Container = styled.div`
  position: relative;
  width: 320px;
  padding: 0 16px;
  margin-bottom: 88px;

  @media (min-width: 768px) {
    width: 768px;
    padding: 0 34px;
    margin-bottom: 704px;
  }

  @media (min-width: 1440px) {
    width: 1440px;
    padding: 0 250px;
  }
`;

export const Title = styled.h2`
  font-size: 17px;
  font-weight: 900;
  line-height: 24px;
  letter-spacing: 0.04em;
  color: #7165e3;
  margin-bottom: 40px;

  @media (min-width: 768px) {
    margin-right: 80px;
    width: 266px;
    font-size: 24px;
    line-height: 36px;
    margin-bottom: 30px;
    animation: ${textAnimation} 1800ms ease-in-out;
  }

  @media (min-width: 1440px) {
    width: 266px;
    margin-right: 0;
  }
`;

export const Text = styled.p`
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 24px;
  width: 288px;
  margin-bottom: 527px;

  @media (min-width: 768px) {
    margin-right: 86px;
    width: 260px;
    font-size: 16px;
    margin-bottom: 170px;
    animation: ${textAnimation} 1800ms ease-in-out;
  }

  @media (min-width: 1440px) {
    margin-bottom: 60px;
    margin-right: 6px;
  }
`;

export const ScreenThirdSection = styled.img`
  position: absolute;
  width: 240px;
  border-radius: 20px;
  box-shadow: 0 15px 20px 0 rgba(113, 101, 227, 0.2),
    0 15px 20px 0 rgba(113, 101, 227, 0.2);
  left: 0;
  right: 0;
  margin-top: -470px;

  @media (min-width: 768px) {
    width: 320px;
    margin-left: 0px;
    margin-top: -370px;
    z-index: 1;
    left: 34px;
    animation: ${OddScreenSectionAnimation} 1400ms ease-in-out;
  }

  @media (min-width: 1440px) {
    margin-left: 220px;
    margin-top: -268px;
  }
`;

export const ImageThirdSection = styled.img`
  width: 293px;

  @media (min-width: 768px) {
    width: 530px;
    position: absolute;
    margin-left: 166px;
    margin-top: -246px;
    animation: ${OddImageSectionAnimation} 1000ms ease-in-out;
  }

  @media (min-width: 1440px) {
    width: 707px;
    margin-left: 40px;
    margin-top: -268px;
  }
`;
